import { Modal } from 'antd';
import React from 'react';
import PFileList from './PFileList';

export type PFileListModalProps = {
  visible: boolean;
  onChange: (item: any) => void;
  //   onSelect: (item: any) => void;
  onCancel: () => void;
  paydirection:string;
};

const PFileListModal = ({
  onChange,
  visible,
  onCancel,
  paydirection,
}: //   setScoring,
PFileListModalProps) => {
  return (
    (<Modal
      footer=""
      open={visible}
      onCancel={onCancel}
      width={1200}
      destroyOnClose
    >
      <PFileList paydirection={paydirection} onSelect={onChange} />
    </Modal>)
  );
};

export default PFileListModal;
